<template>
    <div class="shiming">
        <div class="tit">
            <span>实名认证</span>
            <div>
                <div>
                    <span>根据互联网账号名称管理规定 ,由于您的账号未通过实名认证,请阅读规定再认证 </span>
                    <!-- <span>根据互联网账号名称管理规定 ,由于您的账号未通过实名认证,请阅读规定再认证</span> -->
                </div>
            </div>
        </div>
        <div class="cont">
            <div class="tit">互联网用户账号名称管理规定</div>
            <div class="content">
                <div v-for="(item, index) in wenzi"
                     :key="index">
                    <span>第{{ index+1 }}条</span>
                    <div>
                        <span>{{ item.text }}</span>
                        <div v-if="item.sub">
                            <div style="text-indent: 1em"
                                 v-for="(ite,idx) in item.sub"
                                 :key="idx">{{ ite }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fooder">
			<template v-if="countdown == 0">

            <img @click="xieyi = !xieyi"
                 v-if="xieyi"
                 src="@/assets/common/yes.png"
                 alt="">
            <img @click="xieyi = !xieyi"
                 v-else
                 src="@/assets/common/no.png"
                 alt="">
			</template>
            <div @click="xieyi = !xieyi">我已阅读,并知晓互联网账号名称管理规定</div>
            <span v-if="countdown != 0">{{ countdown }}秒</span>
        </div>
        <div class="btn"
             @click="startRenzheng"
             v-if="countdown == 0">开始认证</div>

        <el-dialog title="实名认证"
                   :visible.sync="select.show"
                   width="500px"
                   append-to-body>
            <div class="moudle">
                <div class="select">
                    <div v-for="(item, index) in select.arr"
                         :key="index"
                         :class="select.active == index ? 'active' : ''"
                         @click="select.active = index">
                        {{ item.name }}
                    </div>
                </div>

                <div class="btn"
                     @click="selectClick">确定</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import wenzi from './text'
export default {
    data () {
        return {
            wenzi,
            select: {
                show: false,
                arr: [
                    { name: "申请缩水师实名认证", url: "/personalCenter/hangjiaguanli/apply_sss", },
                    { name: "申请投注站帮扶彩票代表实名认证", url: "/personalCenter/tzz_bf/cp_jl_sq", },
                    { name: "申请EXCEL技巧师实名认证", url: "/personalCenter/hangjiaguanli/apply_jqs", },
                    { name: "申请投注站帮扶彩票经理实名认证", url: "/personalCenter/tzz_bf/cp_jl_sq", },
                    { name: "申请软件交易师实名认证", url: "/personalCenter/suoshuiruanjian/apply_jys", },
                    { name: "申请投注站帮扶站长实名认证", url: "/personalCenter/tzz_bf/cp_tzz_sq_bf", },
                ],
                active: 0,
            },
            countdown: 6,  //倒计时
            xieyi: false,
        };
    },
    mounted () {
        let tirm = setInterval(_ => {
            if (this.countdown <= 0) {
                clearInterval(tirm)
                return
            }
            this.countdown--
        }, 1000)
    },
    methods: {
        selectClick () {
            this.select.show = false;
            let { arr, active } = this.select
            console.log(arr[active]);
            this.$router.push(arr[active].url)
        },
        // 开始认证
        startRenzheng () {
            if (!this.xieyi) {
                this.$message({ message: "请先勾选互联网管理规定", type: "error" });
                return
            }
            this.select.show = true
        }
    },
};
</script>

<style lang='scss' scoped>
.shiming {
    > .tit {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        > div {
            margin-left: 20px;
            border: 1px solid;
            padding: 10px;
            width: min-content;
            overflow: hidden;
            > div {
                width: 500px;
                width: min-content;
                display: flex;
                white-space: nowrap;
            }
        }
    }
    .cont {
        .tit {
            text-align: center;
        }
        .content {
            line-height: 25px;
            margin-top: 18px;
            font-size: 14px;
            > div {
                margin-bottom: 20px;
                display: flex;
                // &:hover {
                // 	transform-origin: left;
                //     font-weight: bold;
                //     letter-spacing: 4px;
                // 	background-color: #fff;
                // }
				>div{
					flex: 1;
				}
                span {
                    margin-right: 20px;
                }
            }
        }
    }
    .fooder {
        display: flex;
        align-items: center;
        img {
            width: 25px;
            height: 25px;
        }
        div {
            padding: 10px 30px;
            border: 1px solid;
            margin: 0 10px;
        }
    }
    .btn {
        background-color: #bd3124;
        color: #ffffff;
        display: inline-block;
        margin-left: 150px;
        font-size: 25px;
        padding: 10px 30px;
        margin-top: 30px;
        cursor: pointer;
    }
}
::v-deep.moudle {
    .select {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        border-top: 1px solid #60ade3;
        border-left: 1px solid #60ade3;
        > div {
            padding: 20px 0;
            text-align: center;
            border-bottom: 1px solid #60ade3;
            border-right: 1px solid #60ade3;
            cursor: pointer;
            &.active {
                background-color: #93d2f3;
            }
        }
    }
    .btn {
        background-color: #bd3124;
        color: #ffffff;
        display: inline-block;
        margin-left: 175px;
        font-size: 25px;
        padding: 10px 30px;
        margin-top: 30px;
        cursor: pointer;
    }
}
</style>